import { SvgIcon, SvgIconProps } from "@mui/material";

export const StopIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <rect width="10" height="10" x="7" y="7" fill="currentColor" rx="2" />
    </svg>
  </SvgIcon>
);
